var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-content"},[_c('img',{staticClass:"icon-tip",attrs:{"src":_vm.appData.agentLogoUrl}}),_vm._m(0),_c('div',{staticClass:"buy-button",on:{"click":_vm.addDeviceAction}},[_vm._v("立即充值")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-tip"},[_c('span',[_vm._v("您还未绑定设备，")]),_c('span',{staticClass:"center-item"},[_vm._v("可帮助其他设备进行充值！")])])
}]

export { render, staticRenderFns }